/**
 * setSessionCollectionName
 *
 * Sets the current session collection name.
 *
 * Writes to Redux state (via `setCollectionName` action) — keeps the
 * debounced localStorage persist and backward compat with remaining
 * Redux consumers.
 */
import { getStore } from '@/store/store-proxy';
import { setCollectionName } from '@/store/slices/sessionSlice';
export const setSessionCollectionName = (collectionName) => {
    getStore().dispatch(setCollectionName(collectionName));
};
